export const MENU_OPTION = {
  SHARE: "share",
  MOVE: "move",
  DELETE: "delete",
}

export const MESSAGE_TYPE = {
  SUCCESS: "success",
  SAVE_ERROR: "saveError",
  REQUIRED: "isRequired",
  ALREADY_EXISTS: "alreadyExists",
}
